import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS, track, whatsappLink } from "../lib/site";

const VENUES = [
  {
    name: "The Garden Table",
    kind: "All-day multi-cuisine dining",
    detail: "Gujarati thalis, North Indian classics and continental comforts served under a canopy of green. Breakfast here is a slow, generous affair — and it's included with every stay.",
    hours: "7 AM – 10:30 PM",
  },
  {
    name: "The Poolside Grill",
    kind: "Evening grills & small plates",
    detail: "Charcoal-grilled kebabs, paneer tikka and seasonal vegetables served poolside as the light goes gold. The resort's favourite seat at sunset.",
    hours: "5 PM – 11 PM",
  },
  {
    name: "The Tea Lounge",
    kind: "High tea, coffee & patisserie",
    detail: "Masala chai, single-origin coffee and a glass case of cakes — the quiet room for reading, talking and doing very little.",
    hours: "10 AM – 8 PM",
  },
  {
    name: "In-Room Dining",
    kind: "Private dining, any hour",
    detail: "The full menu, brought to your balcony, cottage garden or suite — for mornings that shouldn't be rushed and nights that shouldn't end.",
    hours: "24 hours",
  },
];

export default function Dining() {
  const { settings } = useSite();
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[0]}
        eyebrow="Dining"
        lines={[<>A table</>, <em>worth slowing for.</em>]}
        lede="Estate-grown produce, Gujarati warmth and menus that move with the seasons — across four settings, from garden breakfasts to midnight plates."
      />
      <section className="section-pad intro" data-testid="dining-venues">
        <div className="venue-list">
          {VENUES.map((venue, i) => (
            <Reveal key={venue.name} delay={i * 0.06} className="venue-row" data-testid={`venue-${i}`}>
              <span className="ritual-num">{String(i + 1).padStart(2, "0")}</span>
              <div>
                <span className="venue-kind">{venue.kind}</span>
                <h3>{venue.name}</h3>
                <p>{venue.detail}</p>
              </div>
              <span className="ritual-time">{venue.hours}</span>
            </Reveal>
          ))}
        </div>
        <Reveal className="center-row">
          <a
            className="gold-button"
            href={whatsappLink("Hello Madhubhan Resort & Spa, I would like to reserve a table.", settings.whatsapp)}
            target="_blank" rel="noreferrer"
            onClick={() => track("whatsapp_click", { location: "dining_page" })}
            data-testid="dining-reserve-link"
          >
            Reserve a table <ArrowUpRight size={16} />
          </a>
        </Reveal>
      </section>
    </main>
  );
}
